<template>
  <div
    class="scroll-progress-bar"
    :style="{ width: `${progressWidth}%` }"
  ></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const progressWidth = ref(0);

const updateProgress = () => {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  progressWidth.value = (scrollTop / docHeight) * 100;
};

onMounted(() => {
  window.addEventListener("scroll", updateProgress);
});

onUnmounted(() => {
  window.removeEventListener("scroll", updateProgress);
});
</script>

<style lang="scss" scoped>
.scroll-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 4px; /* Thickness of the progress bar */
  background-color: var(--orange); /* Color of the progress bar */
  transition: width 0.1s ease;
  z-index: 99999999;
}
</style>
